var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCudos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_33159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37275 0 0 5.37275 0 12C0 18.6273 5.37275 24 12 24C18.6273 24 24 18.6273 24 12C24 5.37275 18.6276 0 12 0ZM12 17.4149C9.01438 17.4149 6.58514 14.9856 6.58514 12C6.58514 9.01438 9.01438 6.58514 12 6.58514C14.9856 6.58514 17.4149 9.01438 17.4149 12C17.4149 14.9856 14.9856 17.4149 12 17.4149ZM1.32778 12C1.32778 6.33828 5.75998 1.69448 11.3368 1.35038V5.28989C7.92422 5.62337 5.25736 8.49977 5.25736 11.9997C5.25736 15.4995 7.92422 18.3763 11.3368 18.7094V22.6489C5.76033 22.3048 1.32812 17.661 1.32812 11.9993L1.32778 12ZM12.6632 22.6496V18.7101C16.0758 18.3766 18.7426 15.5002 18.7426 12.0003C18.7426 8.50046 16.0758 5.62372 12.6632 5.29057V1.35038C18.2397 1.69448 22.6719 6.33828 22.6719 12C22.6719 17.6617 18.2397 22.3055 12.6632 22.6496Z",
    fill: "url(#paint0_linear_3423_33159)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3423_33159",
    x1: 3.51461,
    y1: 20.4854,
    x2: 20.4854,
    y2: 3.51461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C80E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91D2F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_33159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCudos);
export default __webpack_public_path__ + "static/media/cudos.ab48bf556c7a32696c1a2ea7af4ec1ee.svg";
export { ForwardRef as ReactComponent };